import { Component, OnInit, inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import {
  MatTableDataSource,
  MatTable,
  MatColumnDef,
  MatHeaderCellDef,
  MatHeaderCell,
  MatCellDef,
  MatCell,
  MatHeaderRowDef,
  MatHeaderRow,
  MatRowDef,
  MatRow
} from "@angular/material/table";
import { VisitSchedule } from "@app/models/rest/visit-schedule";

@Component({
  selector: "app-show-schedules-dialog",
  templateUrl: "./show-schedules-dialog.component.html",
  styleUrls: ["./show-schedules-dialog.component.css"],
  imports: [
    MatTable,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatCellDef,
    MatCell,
    MatHeaderRowDef,
    MatHeaderRow,
    MatRowDef,
    MatRow
  ]
})
export class ShowSchedulesDialogComponent implements OnInit {
  dialogRef = inject<MatDialogRef<ShowSchedulesDialogComponent>>(MatDialogRef);
  data = inject(MAT_DIALOG_DATA);

  displayedColumns = ["quantity", "sorCode", "externalScheduleReference"];
  schedulesData: MatTableDataSource<VisitSchedule> =
    new MatTableDataSource<VisitSchedule>();

  ngOnInit() {
    // console.log(this.data.visit);
    this.schedulesData.data = this.data.visit?.visitScheduleList;
  }
}
